export const locale = {
    lang: 'es',
    data: {
        MODAL_CREATE_RATING: {
            TITLE: 'Calificar el pedido',
            SUB_TITLE: 'Ayúdenos a mejorar nuestros servicios calificando su pedido.',
            COMMENTS: 'Comentario y Sugerencia',
            MODAL: {
                BUTTONS: {
                    CANCEL: 'Cancelar',
                    SAVE: 'Guardar'
                }
            }
        },
    },
};
